<script>
export default {
  name: 'FadeTransition',
}
</script>

<template>
  <transition
    name="fade"
    appear
    mode="out-in"
  >
    <slot></slot>
  </transition>
</template>

<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>
